import  Picto,{pictoProps, pictoState} from "./Picto";
import {connect} from "react-redux";

export interface SignetPictoProps extends pictoProps {
}

export interface SignetPictoState extends pictoState {
}

export class SignetPicto extends Picto<SignetPictoProps,SignetPictoState>{
    constructor(props) {
        super(props);
        this.picto = this.props.theme.pictos.signetPicto;
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(SignetPicto);
